import { render, staticRenderFns } from "./AcountPublicForm.vue?vue&type=template&id=a50b61d8&scoped=true&"
import script from "./AcountPublicForm.vue?vue&type=script&lang=js&"
export * from "./AcountPublicForm.vue?vue&type=script&lang=js&"
import style0 from "./AcountPublicForm.vue?vue&type=style&index=0&id=a50b61d8&scoped=true&lang=scss&"
import style1 from "./AcountPublicForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50b61d8",
  null
  
)

export default component.exports